// @flow

import React from 'react';
import CategorizedPill from '../pills/categorized-pill';
import { findTagTypeMeta } from './tag-types';
import type { TagTypeMeta } from './tag-types';

type TagT = {
  id: string,
  tagType: string,
  tagValue: string,
};

type Props = {
  tag: TagT,
  size?: 'sm' | 'md',
  onRemove?: () => mixed,
  ariaLabel?: string,
  tagTypes: TagTypeMeta[],
};

const TagPill = ({ tag, size, onRemove, ariaLabel, tagTypes }: Props) => {
  const meta = findTagTypeMeta(tagTypes, tag.tagType);
  return (
    <CategorizedPill
      typeLabel={meta.label}
      valueLabel={tag.tagValue}
      color={meta.color}
      size={size}
      onRemove={onRemove}
      removeTooltip={`Remove ${meta.label}: ${tag.tagValue} from this location`}
      ariaLabel={ariaLabel}
    />
  );
};

export default TagPill;
